export default "__VITE_ASSET__3fbe89a2__"